// Nombre verificado de la WABA de Conext por sector (espeja CONEXT_SECTOR_PHONES
// de c_sendTemplate). Sin sector dedicado → "ConextCRM".
import { jwtDecode } from "jwt-decode";

// «Citas ConextCRM» (26/9/2026): número propio (+1 534 202 5902) para fisioterapia, salud, spa,
// consultoría, abogados y «otro»; estética conserva el suyo. Espejo de SECTORS_ON_NUMBER.citas en
// aws_lambdas/_shared_booking/bookingNumberSectors.js (lo vigila _shared_booking/frontMirrors.test.js).
export const CITAS_CONEXT_SECTORS = Object.freeze([
  "fisioterapia", "salud", "spa", "consultoria", "despacho_abogados", "otro",
]);

const CONEXT_SECTOR_NAME = {
  barberia: "ConextCRM Barberías",
  peluquerias: "ConextCRM Peluquerías",
  peluqueria: "ConextCRM Peluquerías",
  peluqueria_unisex: "ConextCRM Peluquerías",
  estetica: "ConextCRM Estética",
  // Canina comparte la WABA de peluquerías → mismo nombre verificado.
  canina: "ConextCRM Peluquerías",
  lavadero: "ConextCRM Lavaderos",
  ...Object.fromEntries(CITAS_CONEXT_SECTORS.map((s) => [s, "Citas ConextCRM"])),
  // Restauración comparte el número de pedidos, cuya identidad verificada es
  // "Pedidos ConextCRM" (espejo de food-orders/src/utils/conextSender.js).
  comida_para_llevar: "Pedidos ConextCRM",
  pizzeria: "Pedidos ConextCRM",
  distribucion: "Pedidos ConextCRM",
  restaurantes: "Pedidos ConextCRM",
};

export function conextSenderName(sector) {
  const key = String(sector || "").toLowerCase().trim();
  return CONEXT_SECTOR_NAME[key] || "ConextCRM";
}

// Sector de la empresa: localStorage → JWT (misma cadena que CompanyConfigContext
// de las otras apps). `token` es el JWT crudo (sin "Bearer ").
export function resolveSector(token) {
  const ls =
    localStorage.getItem("company_sector") ||
    localStorage.getItem("onboarding_sector");
  if (ls) return ls;
  if (token) {
    try {
      const payload = jwtDecode(token);
      return (
        payload?.sector ||
        payload?.sector_selected ||
        payload?.company_sector ||
        ""
      );
    } catch (e) {
      return "";
    }
  }
  return "";
}
